import { makeStyles } from '@mui/styles';
import ToggleButton from 'apollo-react/components/ToggleButton/ToggleButton';
import StarOutline from 'apollo-react-icons/StarOutline';
import StarSolid from 'apollo-react-icons/StarSolid';
import _ from 'lodash';
import qs from 'query-string';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { toggleFavorite } from '../actions/FavoritesActions';
import { addRecentEvent } from '../actions/RecentEventsActions';

const useStyles = makeStyles({
  favoriteButton: {
    marginTop: '-7px',
    '& svg': {
      width: '1em',
      height: '1em',
    },
    '& button': {
      width: 40,
      height: 40,
    },
  },
  starIcon: {
    fontSize: '1.7rem',
  },
});

const UserDataRecord = ({
  recordNumber = null,
  revisionNumber = null,
  queryStringParams = null,
  handleFavorite = true,
  handleRecentEvent = true,
  favorites,
  toggleFavorite,
  addRecentEvent,
}) => {
  const classes = useStyles();
  const location = useLocation();
  const queryString = location.search;
  const qsParams = queryStringParams || qs.parse(queryString) || {};
  const docTitle = `${recordNumber} ${revisionNumber ? `[${revisionNumber}]` : ''}`;

  const isFavorite =
    favorites.findIndex((favorite) => {
      return favorite.EntityType === qsParams.entityType && favorite.EntityKey === docTitle;
    }) !== -1;

  const userRecordQueryString = queryStringParams
    ? qs.stringify(queryStringParams)
    : queryString.substring(1);

  const userRecord = {
    virtualFilePath: location.pathname,
    entityType: qsParams.entityType,
    entityKey: docTitle,
    queryString: userRecordQueryString,
  };

  const handleToggleFavorite = () => {
    toggleFavorite(userRecord);
  };

  useEffect(() => {
    if (handleRecentEvent && !_.isNil(recordNumber)) {
      addRecentEvent(userRecord);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordNumber]);

  if (handleFavorite) {
    return (
      <ToggleButton
        className={classes.favoriteButton}
        defaultIcon={<StarOutline className={classes.starIcon} />}
        activeIcon={<StarSolid className={classes.starIcon} />}
        onChange={handleToggleFavorite}
        checked={isFavorite}
        aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      />
    );
  }

  return null;
};

const mapStateToProps = createStructuredSelector({
  favorites: (state) => state.favorites.data,
});

const mapDispatchToProps = {
  toggleFavorite,
  addRecentEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDataRecord);
